import { FontConfig } from "../types"

export const BODY_8XL_CONFIG: FontConfig = {
  title: "BODY/8xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 40, tw: "text-[40px]" },
    lineHeight: { px: 54, tw: "leading-[54px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 56, tw: "text-[56px]" },
    lineHeight: { px: 72, tw: "leading-[72px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 80, tw: "text-[80px]" },
    lineHeight: { px: 100, tw: "leading-[100px]" },
  },
}
